import React, { ReactNode } from 'react';
import Header from '../Header/Header.tsx';
import Footer from '../Footer/Footer.tsx';
import ScrollToTopButton from '../ScrollButton/ScrollToTopButton.tsx';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs.tsx';
import './PageLayout.scss';

interface PageLayoutProps {
  children: ReactNode;
  errorMessage: string | null
}

const PageLayout: React.FC<PageLayoutProps> = ({ children, errorMessage }) => {
  return (
    <>
      <div className="page-container">
        <div className="main-content">
          <Header errorMessage={errorMessage}/>
          <Breadcrumbs />
          {children}
        </div>
        <Footer />
      </div>
      <ScrollToTopButton />
    </>
  );
};

export default PageLayout;
